import { useState } from 'react';
import { testimonials } from '@/mocks/categories';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  const goPrev = () => {
    setCurrent((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrent((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="font-heading text-foreground-500 text-lg italic">
            ( What Our Community Say )
          </span>
        </div>

        <div className="relative">
          <div className="flex items-start gap-4 mb-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-foreground-900">
              <i className="ri-star-fill text-yellow-400 text-sm"></i>
              <span className="text-background-50 text-sm font-bold">4.9</span>
            </div>
          </div>

          <blockquote className="font-heading text-xl md:text-2xl text-foreground-900 leading-relaxed italic">
            &ldquo;{t.text}&rdquo;
          </blockquote>

          <div className="mt-8 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-14 h-14 rounded-full object-cover"
                loading="lazy"
              />
              <div>
                <p className="text-foreground-900 font-semibold text-sm">{t.name}</p>
                <p className="text-foreground-500 text-xs">{t.role}</p>
              </div>
            </div>

            <div className="flex gap-2">
              <button
                onClick={goPrev}
                className="w-12 h-12 rounded-xl border border-background-300 flex items-center justify-center text-foreground-600 hover:bg-background-200 transition-colors cursor-pointer"
                aria-label="Previous testimonial"
              >
                <i className="ri-arrow-left-line text-lg"></i>
              </button>
              <button
                onClick={goNext}
                className="w-12 h-12 rounded-xl bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
                aria-label="Next testimonial"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}